// theme constant
export const gridSpacing = 2;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const platform = 'dev';
